import React, { useEffect, useState } from 'react'
import { getTemporalLabel } from '../api'
import { useApi } from '../../../../hooks/useApi'
import { Status } from '../../../../hooks/useFetchState'
import { DocumentPrint } from '../../../UI/DocumentPrint/DocumentPrint'
import { Loading } from '../../../UI'
import { Typography } from '@mui/material'

interface LabelTempProps {
  pickingRouteId: number
}

export const Labeltemp: React.FC<LabelTempProps> = ({ pickingRouteId }) => {
  const [temporalLabel, setTemporalLabel] = useState<string>('')
  const [errorRequest, setErrorRequest] = useState<string>('')
  const { state: requestFileState, callApi: reqGetTemporalLabel } = useApi()

  const requestGetTemporalLabel = (selectedPickingRouteId: number) => {
    reqGetTemporalLabel(getTemporalLabel(selectedPickingRouteId))
      .then((response) => {
        setTemporalLabel(response)
        setErrorRequest('')
      })
      .catch((error) => {
        setErrorRequest('Error al obtener etiqueta temporal')
        console.log(error)
      })
  }

  useEffect(() => {
    requestGetTemporalLabel(pickingRouteId)
  }, [])

  if (requestFileState.status === Status.Loading || pickingRouteId === 0) {
    return <Loading /> // durante carga
  } else {
    if (errorRequest === '') {
      return <DocumentPrint documentPDF={temporalLabel} type='base64' />
    } else {
      return <Typography variant='h6'>{errorRequest}</Typography>
    }
  }
}
